function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import SvgCross from "@digital-hig/icon/lib/esm/icons/cross";
export var makeAutocompleteStyles = function makeAutocompleteStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiAutocomplete: {
      defaultProps: {
        clearIcon: /*#__PURE__*/React.createElement(SvgIcon, {
          fontSize: "small"
        }, /*#__PURE__*/React.createElement(SvgCross, null)),
        componentsProps: {
          clearIndicator: {
            tabIndex: 0
          }
        }
      },
      styleOverrides: {
        root: {
          '&[class*="DhigCombobox"]': {
            '&[class*="MuiAutocomplete-hasPopupIcon"]': {
              '& [class*="MuiAutocomplete-inputRoot"]': {
                paddingRight: primitives.spacings["3"]
              }
            },
            '& [class*="DhigCombobox--textField"]': {
              '& [class*="DhigCombobox--input"][class*="MuiInputBase-inputAdornedEnd"]': {
                padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"])
              }
            }
          },
          '& [class*="DhigCombobox--textField"]': {
            '& [class*="MuiInput-root"]': {
              display: "flex",
              flexWrap: "wrap",
              paddingRight: primitives.spacings["0"]
            },
            '& [class*="MuiAutocomplete-endAdornment"]': {
              display: "flex",
              flexDirection: "row",
              marginRight: "0",
              top: primitives.spacings["2"],
              right: primitives.spacings["2"],
              minWidth: "fit-content",
              gap: primitives.spacings["1"],
              "& button": {
                color: tokens.colors["ink-on-background"]
              }
            }
          },
          '& [class*="DhigCombobox--input"]': {},
          '&[class*="DhigCombobox--multiple"]': {
            '& [class*="DhigCombobox--textField"]': {
              '& [class*="MuiInput-root"]': {
                paddingLeft: primitives.spacings["3"],
                paddingBottom: primitives.spacings["2"],
                minHeight: primitives.spacings["8"],
                '& [class*="MuiChip-root"]': {
                  margin: "".concat(primitives.spacings["2"], " 2px ").concat(primitives.spacings["0"])
                }
              }
            }
          },
          '&[class*="DhigCombobox--layout--grow"]': {
            '& [class*="DhigCombobox--textField"]': {
              maxHeight: "212px",
              '& [class*="MuiInput-root"]': {
                // highly specific to override input styles, see issue #717
                '&[class*="MuiInputBase-root"]': {
                  "&.Mui-focused:not(.Mui-disabled):before": {
                    boxShadow: "none"
                  }
                },
                overflow: "auto",
                paddingRight: "46px",
                "&::before": {
                  borderBottom: "none"
                },
                "&::after": {
                  borderBottom: "none"
                },
                "&:hover": {
                  "&::before": {
                    boxShadow: "none"
                  }
                },
                '& [class*="DhigCombobox--input"]': {
                  flexBasis: "min-content",
                  padding: primitives.spacings["0"],
                  margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"]),
                  flexGrow: "1",
                  transform: "translateY(".concat(primitives.spacings["1"], ")"),
                  "&:focus": {
                    minWidth: "15ch"
                  }
                }
              }
            }
          },
          '&[class*="DhigCombobox--layout--fixed"]': {
            '& [class*="DhigCombobox--textField"]': {
              '& [class*="MuiInput-root"]': {
                flexWrap: "nowrap",
                paddingTop: primitives.spacings["2"],
                '& [class*="MuiChip-root"]': {
                  marginTop: primitives.spacings["0"]
                },
                '& [class*="DhigCombobox--input"]': {
                  padding: primitives.spacings["0"],
                  marginLeft: primitives.spacings["1"]
                }
              }
            }
          },
          '&[class*="DhigSearch"]': {},
          '& [class*="DhigSearch--textField"]': {
            backgroundColor: tokens.colors["search-field-fill"],
            borderRadius: primitives.spacings[1],
            height: "40px",
            '& [class*="MuiAutocomplete-inputRoot"]': _objectSpread(_objectSpread({
              borderRadius: primitives.spacings[1],
              border: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.detail.transparent),
              boxShadow: "none",
              flexWrap: "nowrap",
              height: "100%"
            }, tokens.transitions["state-blur"]), {}, {
              "&.Mui-focused": _objectSpread({
                border: "1px solid ".concat(primitives.colors.accent.iris)
              }, tokens.transitions["state-activate"]),
              "&.Mui-disabled": {
                '& [class*="MuiInputAdornment-root"]': {
                  opacity: tokens.opacities.disabled
                },
                pointerEvents: "none",
                color: tokens.colors["ink-on-background"]
              },
              "&:focus, &:focus:active": _objectSpread({
                border: "".concat(primitives.borderWidths.large, " solid ").concat(primitives.colors.accent.iris)
              }, tokens.transitions["state-activate"]),
              "&:active": _objectSpread({
                border: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.accent.iris)
              }, tokens.transitions["state-activate"]),
              "&:hover, &.Mui-focused:not(:hover)": _objectSpread(_objectSpread({
                backgroundColor: tokens.colors["hover-fill-subtle"]
              }, tokens.transitions["state-activate"]), {}, {
                '&[class*="MuiInput-root"]': {
                  boxShadow: "none"
                }
              }),
              '& [class*="MuiInputAdornment-root"]': {
                width: "unset",
                paddingLeft: primitives.spacings["2"],
                paddingRight: primitives.spacings["0"],
                marginRight: primitives.spacings["0"],
                '& [class*="MuiSvgIcon-root"]': {
                  height: "24px",
                  width: "unset"
                }
              }
            }),
            '& [class*="DhigSearch--input"]': {
              padding: primitives.spacings["1"]
            },
            '& [class*="MuiAutocomplete-endAdornment"]': {
              top: "unset",
              marginRight: primitives.spacings["2"]
            }
          },
          '& [class*="DhigSearch--input"]': {},
          '& [class*="MuiTextField-root"]': {
            minHeight: "40px",
            '& [class*="MuiInput-root"]': {
              paddingBottom: primitives.spacings["0"],
              color: tokens.colors["ink-on-background"],
              '& [class*="MuiAutocomplete-endAdornment"]': _objectSpread(_objectSpread({
                height: primitives.spacings["6"],
                width: primitives.spacings["6"]
              }, tokens.transitions["state-blur"]), {}, {
                '& [class*="MuiAutocomplete-clearIndicator"]': {
                  visibility: "unset",
                  opacity: 0,
                  '& [class*="MuiSvgIcon-root"]': {
                    color: tokens.colors["ink-on-background"]
                  },
                  "&:hover": _objectSpread({
                    backgroundColor: tokens.colors["hover-fill-subtle"]
                  }, tokens.transitions["state-activate"]),
                  "&:active": _objectSpread({
                    backgroundColor: tokens.colors["pressed-fill-subtle"]
                  }, tokens.transitions["state-activate"]),
                  "&:focus, &:focus-visible": _objectSpread(_objectSpread({
                    outline: "none",
                    boxShadow: tokens.effects["focus-ring-thin"]
                  }, tokens.transitions["state-activate"]), {}, {
                    "&:hover, &:active": {
                      backgroundColor: tokens.colors["fill-elevation-0"]
                    }
                  })
                }
              })
            },
            "&:hover, &:focus-within": {
              '& [class*="MuiAutocomplete-endAdornment"]': {
                '& [class*="MuiAutocomplete-clearIndicator"]': {
                  opacity: 1
                }
              }
            }
          },
          "& [class*='MuiTextField-root']": {
            "& [class*='MuiInput-root']": {
              "& [class*='MuiAutocomplete-endAdornment']": {
                minHeight: "40px",
                top: "0",
                transform: "unset",
                maxHeight: primitives.spacings["8"],
                height: "100%",
                display: "flex",
                alignItems: "center",
                "& [class*='MuiButtonBase-root']": {
                  height: primitives.spacings["6"]
                }
              }
            }
          }
        }
      }
    }
  };
};